import { ENV } from '../constants';
import { BASE_URL } from '../constants';

// const CONST_PROD_NEW_KBANK = {
//     SCRIPT_URL: 'https://dev-kpaymentgateway.kasikornbank.com/ui/v2/kpayment.min.js',
//     PUBLIC_KEY: 'pkey_test_20923L43S4RABbtwVoMIzsopFCYzyZnyMwFsn',
//     SHOP_NAME: 'SF SHOP DEV/UAT',
//     REDIRECT_URL : `${BASE_URL}/api/ConfirmPayment/KBankReturn`,
//     MID : "401001039565001"
// };

// const CONST_DEV_NEW_KBANK = {
//     SCRIPT_URL: 'https://dev-kpaymentgateway.kasikornbank.com/ui/v2/kpayment.min.js',
//     PUBLIC_KEY: 'pkey_test_4yjnn1eMIUVRFuYKbnRKrVIKAzUC2r3vy',
//     SHOP_NAME: 'SF SHOP DEV/UAT',
//     REDIRECT_URL : `${BASE_URL}/api/ConfirmPayment/KBankReturn`,
//     MID : "401001039565001",
// };

const CONST_DEV_KBANK = {
    BANK_HOST: 'https://uatkpgw.kasikornbank.com',
    MERCHANT2: '401001039565001',
    TERM2: '70340889',
    DETAIL2: 'SF SHOP DEV/UAT'
};
const CONST_PROD_KBANK = {
    BANK_HOST: 'https://rt05.kasikornbank.com',
    MERCHANT2: '401001286285001',
    TERM2: '70345252',
    DETAIL2: 'SF SHOP'
};

// const SCRIPT_URL = 
//     ENV === 'production'
//         ? CONST_PROD_NEW_KBANK.SCRIPT_URL
//         : CONST_DEV_NEW_KBANK.SCRIPT_URL;

// const PUBLIC_KEY = 
//     ENV === 'production'
//         ? CONST_PROD_NEW_KBANK.PUBLIC_KEY
//         : CONST_DEV_NEW_KBANK.PUBLIC_KEY;
// const SHOP_NAME = 
//     ENV === 'production'
//         ? CONST_PROD_NEW_KBANK.SHOP_NAME
//         : CONST_DEV_NEW_KBANK.SHOP_NAME;
    
// const REDIRECT_URL = 
//     ENV === 'production'
//         ? CONST_PROD_NEW_KBANK.REDIRECT_URL
//         : CONST_DEV_NEW_KBANK.REDIRECT_URL;

// const MID = 
//     ENV === 'production'
//         ? CONST_PROD_NEW_KBANK.REDIRECT_URL
//         : CONST_DEV_NEW_KBANK.REDIRECT_URL;

const BANK_HOST =
    ENV === 'production'
        ? CONST_PROD_KBANK.BANK_HOST
        : CONST_DEV_KBANK.BANK_HOST;
const MERCHANT2 =
    ENV === 'production'
        ? CONST_PROD_KBANK.MERCHANT2
        : CONST_DEV_KBANK.MERCHANT2;
const TERM2 =
    ENV === 'production' ? CONST_PROD_KBANK.TERM2 : CONST_DEV_KBANK.TERM2;
const DETAIL2 =
    ENV === 'production' ? CONST_PROD_KBANK.DETAIL2 : CONST_DEV_KBANK.DETAIL2;

export const KBANK = {
    // SCRIPT_URL : SCRIPT_URL,
    // PUBLIC_KEY : PUBLIC_KEY,
    // SHOP_NAME : SHOP_NAME,
    // REDIRECT_URL : REDIRECT_URL ,
    // MID : MID,
    BANK_HOST: `${BANK_HOST}/pgpayment/payment.aspx`,
    MERCHANT2: MERCHANT2, //'401001286285001',
    TERM2: TERM2, //'70345252',
    AMOUNT2: '100',
    URL2: `${BASE_URL}/api/ConfirmPayment/BankReturn`,
    RESPURL: '',
    IPCUST2: '35.186.149.81',
    DETAIL2: DETAIL2, //'SF SHOP',
    INVMERCHANT: '000000000001',
    FILLSPACE: 'Y',
    SHOPID: '',
    PAYTERM2: '',
    CHECKSUM: ''
};
